import { toggleCharm, HeaderCharmType } from 'owa-header-store';
import { action } from 'satcheljs/lib/legacy';

export default action('launchHelpPane')(function launchHelpPane() {
    toggleCharm(HeaderCharmType.HelpCharm);
});
